export enum Player {
  PLAYER_1 = 'PLAYER_1',
  PLAYER_2 = 'PLAYER_2'
}

export enum Phase {
  DRAW = 'DP',
  STANDBY = 'SP',
  MAIN_1 = 'M1',
  BATTLE = 'BP',
  MAIN_2 = 'M2',
  END = 'EP'
} 